<template>
  <div class="contenedor-principal" :style="getCantidad" id="printMe">
    <div class="content">
      <div class="contenedor-header">
        <img src="../../assets/imgs/logorm.svg" alt="icon-logo" />
        <p class="p-direccion">
          Carlos M., C. Esquerro 2298,<br />
          Col. Libertad, C.P.80180, <br />
          Culiacán, Sin., (667)-154-6149
        </p>
        <p class="p-direccion"></p>
      </div>
      <div class="info-dinamica">
        <div class="info-top">
          <p>
            <span class="title-info">Fecha: </span
            ><span>{{
              venta.fechaOriginal ? venta.fechaOriginal : venta.fecha
            }}</span>
          </p>
          <p>
            <span class="title-info">Cliente: </span
            ><span>{{ venta.cliente }}</span>
          </p>
          <p>
            <span class="title-info">Placa y Vehículo: </span
            ><span>{{ venta.vehiculo }}</span>
          </p>
          <p>
            <span class="title-info">Marca: </span
            ><span>{{ venta.marca }}</span>
          </p>
          <p>
            <span class="title-info">Folio: </span
            ><span>{{ venta.folio }}</span>
          </p>
          <p v-if="venta.concepto">
            <span class="title-info">Concepto: </span
            ><span>{{ venta.concepto }}</span>
          </p>
        </div>
        <div id="carrito" class="content-carrito">
          <div id="titulares">
            <h3 id="cantidad">No.</h3>
            <h3 id="descripcion">DESCRIPCIÓN</h3>
            <h3 id="total">TOTAL</h3>
          </div>
          <div id="main-compra">
            <div class="carrito-compra" v-for="producto in venta.sales_details" :key="producto.id">
              <p class="detalle-cantidad">{{ producto.quantity }}</p>
              <p class="detalle-prod">
                {{
                  producto.product
                    ? producto.product?.name
                    : producto.service?.name
                    ? producto.service?.name
                    : "ND"
                }}
              </p>
              <p class="detalle-costo">{{ getCostoArticulo(producto) }}</p>
            </div>
          </div>
        </div>
        <div v-if="venta.nota" class="mano-obra">
          <span>MANO DE OBRA: </span><br />
          <span>{{ venta.nota }}</span>
        </div>
        <p class="reimpresion" v-if="venta.reimpresion">*** REIMPRESIÓN ***</p>
        <div id="totales" class="contenedor-totales">
          <div id="primer-calculo">
            <div id="subtotal">
              <p>Subtotal</p>
              <p>{{ getSubTotal }}</p>
            </div>
            <div id="iva">
              <p>IVA</p>
              <p>{{ getIVA }}</p>
            </div>
            <div id="total-venta">
              <p>TOTAL</p>
              <p>{{ getTotal }}</p>
            </div>
          </div>

          <div id="segundo-calculo" v-if="!venta.reimpresion">
            <div id="forma-pago">
              <p>Forma de pago</p>
              <p>{{ this.venta.formaPago ? this.venta.formaPago : "ND" }}</p>
            </div>
            <div id="pago-total" class="pago-total" v-if="this.venta.esEfectivo">
              <p>Pago</p>
              <p>{{ getEfectivo }}</p>
            </div>
            <div id="cambio-total" v-if="this.venta.esEfectivo">
              <p>Cambio</p>
              <p>{{ getCambio }}</p>
            </div>
          </div>
        </div>
      </div>
      <div id="footer" class="aviso">
        <p>*** <span> GRACIAS POR SU VISITA </span> ***</p>
      </div>
    </div>
  </div>
</template>

<script>
import monedaMixin from "../../mixins/moneda.js";
/* eslint-disable */

export default {
  name: "Ticket-venta",
  props: {
    venta: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    getSubTotal() {
      return this.venta.subTotal
        ? `$${monedaMixin.formatPrice(this.venta.subTotal)}`
        : "$0.00";
    },
    getIVA() {
      return this.venta.iva
        ? `$${monedaMixin.formatPrice(this.venta.iva)}`
        : "$0.00";
    },
    getTotal() {
      return this.venta.total
        ? `$${monedaMixin.formatPrice(this.venta.total)}`
        : "$0.00";
    },
    getCambio() {
      return this.venta.cambio
        ? `$${monedaMixin.formatPrice(this.venta.cambio)}`
        : "$0.00";
    },
    getEfectivo() {
      return this.venta.efectivocapturado
        ? `$${monedaMixin.formatPrice(this.venta.efectivocapturado)}`
        : "$0.00";
    },
    getCantidad() {
      let altura = this.venta.cantidadArticulos * 80; // Aumentado para descripciones más largas
      altura += 790;
      this.venta.nota ? (altura += 80) : altura;
      this.venta.concepto ? (altura += 50) : altura;
      
      return `max-height: ${altura}px;`;
    },
  },
  methods: {
    getCostoArticulo(producto) {
      return "$" + monedaMixin.formatPrice(producto.price * producto.quantity);
    },
  },
};
</script>


<style scoped src="@/assets/css/ticketVenta.css">
</style>
